module.exports = function(gantt) {
	var domHelpers = require("../utils/dom_helpers");

	gantt._lightbox_methods = {};
	gantt._lightbox_template = "<div class='gantt_cal_ltitle'><span class='gantt_mark'>&nbsp;</span><span class='gantt_time'></span><span class='gantt_title'></span></div><div class='gantt_cal_larea'></div>";


	//TODO: gantt._lightbox_id is changed from data.js and accessed from autoscheduling, check if it can be removed from gantt object
	var state = gantt.$services.getService("state");
	state.registerProvider("lightbox", function(){
		return {
			lightbox: gantt._lightbox_id
		};
	});

	gantt.showLightbox = function (id) {
		if (!id || gantt.isReadonly(this.getTask(id))) return;
		if (!this.callEvent("onBeforeLightbox", [id])) return;

		var task = this.getTask(id);

		var box = this.getLightbox(this.getTaskType(task.type));
		this._center_lightbox(box);
		this.showCover();
		this._fill_lightbox(id, box);

		this._waiAria.lightboxVisibleAttr(box);

		this.callEvent("onLightbox", [id]);
	};
	gantt._get_timepicker_step = function () {
		if (this.config.round_dnd_dates) {
			var scale = gantt.getScale(),
				step = (this._get_line(scale.unit) * scale.step) / 60;//timepicker step is measured in minutes
			if (step >= 60 * 24 || !this._is_chart_visible()) {
				step = this.config.time_step;
			}
			return step;
		}
		return this.config.time_step;
	};
	gantt.getLabel = function (property, key) {
		var sections = this._get_typed_lightbox_config();
		for (var i = 0; i < sections.length; i++) {
			if (sections[i].map_to == property) {
				var options = sections[i].options;
				for (var j = 0; j < options.length; j++) {
					if (options[j].key == key) {
						return options[j].label;
					}
				}
			}
		}
		return "";
	};

	gantt.updateCollection = function (list_name, collection) {
		collection = collection.slice(0);
		var list = gantt.serverList(list_name);
		if (!list) return false;
		list.splice(0, list.length);
		list.push.apply(list, collection || []);
		gantt.resetLightbox();
	};
	gantt.getLightboxType = function () {
		return this.getTaskType(this._lightbox_type);
	};
	gantt.getLightbox = function (type) {
		if (type === undefined)
			type = this.getLightboxType();

		if (!this._lightbox || this.getLightboxType() != this.getTaskType(type)) {
			this._lightbox_type = this.getTaskType(type);
			var d = document.createElement("DIV");
			d.className = "gantt_cal_light";

			var full_width = this._is_lightbox_timepicker();
			if (gantt.config.wide_form || full_width)
				d.className += " gantt_cal_light_wide";

			if (full_width) {
				gantt.config.wide_form = true;
				d.className += " gantt_cal_light_full";
			}


			d.style.visibility = "hidden";

			var html = this._lightbox_template;

			var ariaAttr;
			var buttons = this.config.buttons_left;
			for (var i = 0; i < buttons.length; i++) {
				// needed to migrate from 'dhx_something' to 'gantt_something' naming in a lightbox
				var button = this.config._migrate_buttons[buttons[i]] ? this.config._migrate_buttons[buttons[i]] : buttons[i];

				ariaAttr = this._waiAria.lightboxButtonAttrString(button);
				html += "<div " + ariaAttr + " class='gantt_btn_set gantt_left_btn_set " + button + "_set'><div dhx_button='1' class='" + button + "'></div><div>" + this.locale.labels[button] + "</div></div>";

			}
			buttons = this.config.buttons_right;
			for (var i = 0; i < buttons.length; i++) {
				var button = this.config._migrate_buttons[buttons[i]] ? this.config._migrate_buttons[buttons[i]] : buttons[i];
				ariaAttr = this._waiAria.lightboxButtonAttrString(button);

				html += "<div " + ariaAttr + " class='gantt_btn_set gantt_right_btn_set " + button + "_set' style='float:right;'><div dhx_button='1' class='" + button + "'></div><div>" + this.locale.labels[button] + "</div></div>";

			}
			html += "</div>";
			d.innerHTML = html;

			gantt._waiAria.lightboxAttr(d);

			if (gantt.config.drag_lightbox) {
				d.firstChild.onmousedown = gantt._ready_to_dnd;
				d.firstChild.onselectstart = function () {
					return false;
				};
				d.firstChild.style.cursor = "pointer";
				gantt._init_dnd_events();

			}

			document.body.insertBefore(d, document.body.firstChild);
			this._lightbox = d;

			var sns = this._get_typed_lightbox_config(type);
			html = this._render_sections(sns);

			var ds = d.getElementsByTagName("div");
			for (var i = 0; i < ds.length; i++) {
				var t_ds = ds[i];
				if (t_ds.className == "gantt_cal_larea") {
					t_ds.innerHTML = html;
					break;
				}
			}

			// bind labels to lightbox inputs
			for (var i = 0; i < sns.length; i++) {
				var section = sns[i];
				if (!section.id || !document.getElementById(section.id))
					continue;

				var labelBlock = document.getElementById(section.id);
				var label = labelBlock.querySelector("label");
				var inputBlock = labelBlock.nextSibling;
				if (!inputBlock)
					continue;

				var input = inputBlock.querySelector("input, select, textarea");
				if (input) {
					section.inputId = input.id || "input_" + gantt.uid();
					if (!input.id)
						input.id = section.inputId;

					label.setAttribute("for", section.inputId);
				}
			}

			//sizes
			this.resizeLightbox();

			this._init_lightbox_events(this);
			d.style.display = "none";
			d.style.visibility = "visible";
		}
		return this._lightbox;
	};

	gantt._render_sections = function (sns) {
		var html = "";
		for (var i = 0; i < sns.length; i++) {
			var block = this.form_blocks[sns[i].type];
			if (!block) continue; //ignore incorrect blocks
			sns[i].id = "area_" + this.uid();

			var display = sns[i].hidden ? " style='display:none'" : "";
			var button = "";
			if (sns[i].button) {
				button = "<div class='gantt_custom_button' index='" + i + "'><div class='gantt_custom_button_" + sns[i].button + "'></div><div class='gantt_custom_button_label'>" + this.locale.labels["button_" + sns[i].button] + "</div></div>";
			}
			if (this.config.wide_form) {
				html += "<div class='gantt_wrap_section' " + display + ">";
			}
			html += "<div id='" + sns[i].id + "' class='gantt_cal_lsection'><label>" + button + this.locale.labels["section_" + sns[i].name] + "</label></div>" + block.render.call(this, sns[i]);
			html += "</div>";
		}
		return html;
	};


	gantt.resizeLightbox = function () {
		var d = this._lightbox;
		if (!d) return;

		var con = d.childNodes[1];
		con.style.height = "0px";
		con.style.height = con.scrollHeight + "px";
		d.style.height = con.scrollHeight + this.config.lightbox_additional_height + "px";
		con.style.height = con.scrollHeight + "px"; //it is incredible , how ugly IE can be


	};

	gantt._center_lightbox = function (box) {
		if (box) {
			box.style.display = "block";

			var scroll_top = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
			var scroll_left = window.pageXOffset || document.body.scrollLeft || document.documentElement.scrollLeft;

			var view_height = window.innerHeight || document.documentElement.clientHeight;

			if (scroll_top) // if vertical scroll on window
				box.style.top = Math.round(scroll_top + Math.max((view_height - box.offsetHeight) / 2, 0)) + "px";
			else // vertical scroll on body
				box.style.top = Math.round(Math.max(((view_height - box.offsetHeight) / 2), 0) + 9) + "px"; // +9 for compatibility with auto tests

			// not quite accurate but used for compatibility reasons
			if (document.documentElement.scrollWidth > document.body.offsetWidth) // if horizontal scroll on the window
				box.style.left = Math.round(scroll_left + (document.body.offsetWidth - box.offsetWidth) / 2) + "px";
			else // horizontal scroll on the body
				box.style.left = Math.round((document.body.offsetWidth - box.offsetWidth) / 2) + "px";
		}
	};
	gantt.showCover = function () {
		if (this._cover) return;

		this._cover = document.createElement("DIV");
		this._cover.className = "gantt_cal_cover";
		var _document_height = ((document.height !== undefined) ? document.height : document.body.offsetHeight);
		var _scroll_height = ((document.documentElement) ? document.documentElement.scrollHeight : 0);
		this._cover.style.height = Math.max(_document_height, _scroll_height) + 'px';
		document.body.appendChild(this._cover);
	};


	gantt._init_lightbox_events = function () {
		gantt.lightbox_events = {};


		gantt.lightbox_events["gantt_save_btn"] = function (e) {
			gantt._save_lightbox();
		};


		gantt.lightbox_events["gantt_delete_btn"] = function (e) {
			if (!gantt.callEvent("onLightboxDelete", [gantt._lightbox_id]))
				return;

			if (gantt.isTaskExists(gantt._lightbox_id)) {
				gantt.$click.buttons["delete"](gantt._lightbox_id);
			} else {
				gantt.hideLightbox();
			}

		};


		gantt.lightbox_events["gantt_cancel_btn"] = function (e) {
			gantt._cancel_lightbox();
		};


		gantt.lightbox_events["default"] = function (e, src) {
			if (src.getAttribute("dhx_button")) {
				gantt.callEvent("onLightboxButton", [src.className, src, e]);
			} else {
				var index, block, sec;

				var className = domHelpers.getClassName(src);
				if (className.indexOf("gantt_custom_button") != -1) {
					if (className.indexOf("gantt_custom_button_") != -1) {
						index = src.parentNode.getAttribute("index");
						sec = src;
						while (sec && domHelpers.getClassName(sec).indexOf("gantt_cal_lsection") == -1) {
							sec = sec.parentNode;
						}
					} else {
						index = src.getAttribute("index");
						sec = src.parentNode;
						src = src.firstChild;
					}
				}

				var sections = gantt._get_typed_lightbox_config();

				if (index) {
					index = index * 1;
					block = gantt.form_blocks[sections[index * 1].type];
					block.button_click(index, src, sec, sec.nextSibling);
				}
			}
		};
		this.event(gantt.getLightbox(), "click", function (e) {
			e = e || window.event;
			var src = e.target ? e.target : e.srcElement;

			var className = domHelpers.getClassName(src);
			if (!className) {
				src = src.previousSibling;
				className = domHelpers.getClassName(src);
			}
			if (src && className && className.indexOf("gantt_btn_set") === 0) {
				src = src.firstChild;
				className = domHelpers.getClassName(src);
			}
			if (src && className) {
				var func = gantt.defined(gantt.lightbox_events[src.className]) ? gantt.lightbox_events[src.className] : gantt.lightbox_events["default"];
				return func(e, src);
			}
			return false;
		});

		gantt.getLightbox().onkeydown = function (e) {
			var event = e || window.event;
			var target = e.target || e.srcElement;
			var buttonTarget = !!(domHelpers.getClassName(target).indexOf("gantt_btn_set") > -1);

			switch ((e || event).keyCode) {
				case 32: {//space
					if ((e || event).shiftKey) return;
					if (buttonTarget && target.click) {
						target.click();
					}
					break;
				}
				case gantt.keys.edit_save:
					if ((e || event).shiftKey) return;
					if (buttonTarget && target.click) {
						target.click();
					} else {
						gantt._save_lightbox();
					}
					break;
				case gantt.keys.edit_cancel:
					gantt._cancel_lightbox();
					break;
				default:
					break;
			}
		};
	};

	gantt._cancel_lightbox = function () {
		var task = this.getLightboxValues();
		this.callEvent("onLightboxCancel", [this._lightbox_id, task.$new]);
		if (gantt.isTaskExists(task.id) && task.$new) {
			this.silent(function(){
				gantt.$data.tasksStore.removeItem(task.id);
				gantt._update_flags(task.id, null);
			});
		}

		this.refreshData();
		this.hideLightbox();
	};

	gantt._save_lightbox = function () {
		var task = this.getLightboxValues();
		if (!this.callEvent("onLightboxSave", [this._lightbox_id, task, !!task.$new]))
			return;

		if (task.$new) {
			delete task.$new;
			this.addTask(task);
		}else if(this.isTaskExists(task.id)){
			this.mixin(this.getTask(task.id), task, true);
			this.refreshTask(task.id);
			this.updateTask(task.id);
		}
		this.refreshData();

		// TODO: do we need any blockable events here to prevent closing lightbox?
		this.hideLightbox();
	};

	gantt._resolve_default_mapping = function (section) {
		var mapping = section.map_to;
		var time_controls = {"time": true, "time_optional": true, "duration": true, "duration_optional": true};
		if (time_controls[section.type]) {
			if (section.map_to == 'auto') {
				mapping = {start_date: "start_date", end_date: "end_date", duration: "duration"};
			} else if (typeof(section.map_to) === "string") {
				mapping = {start_date: section.map_to};
			}
		}

		return mapping;
	};

	gantt.getLightboxValues = function () {
		var task = {};

		if (gantt.isTaskExists(this._lightbox_id)) {
			task = this.mixin({}, this.getTask(this._lightbox_id));
		}

		var sns = this._get_typed_lightbox_config();
		for (var i = 0; i < sns.length; i++) {
			var node = document.getElementById(sns[i].id);
			node = (node ? node.nextSibling : node);
			var block = this.form_blocks[sns[i].type];
			if (!block) continue;
			var res = block.get_value.call(this, node, task, sns[i]);
			var map_to = gantt._resolve_default_mapping(sns[i]);
			if (typeof map_to == "string" && map_to != "auto") {
				task[map_to] = res;
			} else if (typeof map_to == "object") {
				for (var property in map_to) {
					if (map_to[property])
						task[map_to[property]] = res[property];
				}
			}
		}
		return task;
	};


	gantt.hideLightbox = function () {
		var box = this.getLightbox();
		if (box) box.style.display = "none";

		this._waiAria.lightboxHiddenAttr(box);
		this._lightbox_id = null;

		this.hideCover();
		this.callEvent("onAfterLightbox", []);
	};
	gantt.hideCover = function () {
		if (this._cover)
			this._cover.parentNode.removeChild(this._cover);
		this._cover = null;
	};

	gantt.resetLightbox = function () {
		if (gantt._lightbox && !gantt._custom_lightbox)
			gantt._lightbox.parentNode.removeChild(gantt._lightbox);
		gantt._lightbox = null;
	};
	gantt._set_lightbox_values = function (data, box) {
		var task = data;
		var s = box.getElementsByTagName("span");
		var lightboxHeader = [];
		if (gantt.templates.lightbox_header) {
			lightboxHeader.push("");
			lightboxHeader.push(gantt.templates.lightbox_header(task.start_date, task.end_date, task));
			s[1].innerHTML = "";
			s[2].innerHTML = gantt.templates.lightbox_header(task.start_date, task.end_date, task);
		} else {
			lightboxHeader.push(this.templates.task_time(task.start_date, task.end_date, task));
			lightboxHeader.push((this.templates.task_text(task.start_date, task.end_date, task) || "").substr(0, 70)); //IE6 fix
			s[1].innerHTML = this.templates.task_time(task.start_date, task.end_date, task);
			s[2].innerHTML = (this.templates.task_text(task.start_date, task.end_date, task) || "").substr(0, 70); //IE6 fix
		}
		s[1].innerHTML = lightboxHeader[0];
		s[2].innerHTML = lightboxHeader[1];

		gantt._waiAria.lightboxHeader(box, lightboxHeader.join(" "));

		var sns = this._get_typed_lightbox_config(this.getLightboxType());
		for (var i = 0; i < sns.length; i++) {
			var section = sns[i];

			if (!this.form_blocks[section.type]) {
				continue;//skip incorrect sections, same check is done during rendering
			}


			var node = document.getElementById(section.id).nextSibling;
			var block = this.form_blocks[section.type];
			var map_to = gantt._resolve_default_mapping(sns[i]);
			var value = this.defined(task[map_to]) ? task[map_to] : section.default_value;
			block.set_value.call(gantt, node, value, task, section);

			if (section.focus)
				block.focus.call(gantt, node);
		}
		if (data.id)
			gantt._lightbox_id = data.id;
	};
	gantt._fill_lightbox = function (id, box) {
		var task = this.getTask(id);
		this._set_lightbox_values(task, box);
	};


	gantt.getLightboxSection = function (name) {
		var config = this._get_typed_lightbox_config();
		var i = 0;
		for (i; i < config.length; i++)
			if (config[i].name == name)
				break;
		var section = config[i];
		if (!section)
			return null;

		if (!this._lightbox)
			this.getLightbox();
		var header = document.getElementById(section.id);
		var node = header.nextSibling;

		var result = {
			section: section,
			header: header,
			node: node,
			getValue: function (ev) {
				return gantt.form_blocks[section.type].get_value.call(gantt, node, (ev || {}), section);
			},
			setValue: function (value, ev) {
				return gantt.form_blocks[section.type].set_value.call(gantt, node, value, (ev || {}), section);
			}
		};

		var handler = this._lightbox_methods["get_" + section.type + "_control"];
		return handler ? handler(result) : result;
	};

	gantt._lightbox_methods.get_template_control = function (result) {
		result.control = result.node;
		return result;
	};
	gantt._lightbox_methods.get_select_control = function (result) {
		result.control = result.node.getElementsByTagName('select')[0];
		return result;
	};
	gantt._lightbox_methods.get_textarea_control = function (result) {
		result.control = result.node.getElementsByTagName('textarea')[0];
		return result;
	};
	gantt._lightbox_methods.get_time_control = function (result) {
		result.control = result.node.getElementsByTagName('select'); // array
		return result;
	};


	gantt._init_dnd_events = function () {
		this.event(document.body, "mousemove", gantt._move_while_dnd);
		this.event(document.body, "mouseup", gantt._finish_dnd);
		gantt._init_dnd_events = function () {
		};
	};
	gantt._move_while_dnd = function (e) {
		if (gantt._dnd_start_lb) {
			if (!document.gantt_unselectable) {
				document.body.className += " gantt_unselectable";
				document.gantt_unselectable = true;
			}
			var lb = gantt.getLightbox();
			var now = (e && e.target) ? [e.pageX, e.pageY] : [event.clientX, event.clientY];
			lb.style.top = gantt._lb_start[1] + now[1] - gantt._dnd_start_lb[1] + "px";
			lb.style.left = gantt._lb_start[0] + now[0] - gantt._dnd_start_lb[0] + "px";
		}
	};
	gantt._ready_to_dnd = function (e) {
		var lb = gantt.getLightbox();
		gantt._lb_start = [parseInt(lb.style.left, 10), parseInt(lb.style.top, 10)];
		gantt._dnd_start_lb = (e && e.target) ? [e.pageX, e.pageY] : [event.clientX, event.clientY];
	};
	gantt._finish_dnd = function () {
		if (gantt._lb_start) {
			gantt._lb_start = gantt._dnd_start_lb = false;
			document.body.className = document.body.className.replace(" gantt_unselectable", "");
			document.gantt_unselectable = false;
		}
	};


	gantt._focus = function (node, select) {
		if (node && node.focus) {
			if (gantt.config.touch) {
				//do not focus editor, to prevent auto-zoom
			} else {
				try {
					if (select && node.select) node.select();
					node.focus();
				} catch (e) {
				}
			}
		}
	};


	gantt.form_blocks = {
		getTimePicker: function (sns, hidden) {
			var time_format = sns.time_format;
			if (!time_format) {
				// default order
				var time_format = ["%d", "%m", "%Y"];
				if (gantt._get_line(gantt.getScale().unit) < gantt._get_line("day")) {
					time_format.push("%H:%i");
				}
			}
			// map: default order => real one
			sns._time_format_order = {size: 0};


			var cfg = this.config;
			var dt = this.date.date_part(new Date(gantt._min_date.valueOf()));
			var last = 24 * 60, first = 0;
			if (gantt.config.limit_time_select) {
				last = 60 * cfg.last_hour + 1;
				first = 60 * cfg.first_hour;
				dt.setHours(cfg.first_hour);
			}
			var html = "";

			for (var p = 0; p < time_format.length; p++) {
				var time_option = time_format[p];

				// adding spaces between selects
				if (p > 0) {
					html += " ";
				}

				var options = '';
				switch (time_option) {
					case "%Y":
						sns._time_format_order[2] = p;
						sns._time_format_order.size++;
						//year

						var range, offset, start_year, end_year;

						if (sns.year_range) {
							if (!isNaN(sns.year_range)) {
								range = sns.year_range;
							} else if (sns.year_range.push) {
								// if
								start_year = sns.year_range[0];
								end_year = sns.year_range[1];
							}
						}

						range = range || 10;
						offset = offset || Math.floor(range / 2);
						start_year = start_year || dt.getFullYear() - offset;
						end_year = end_year || start_year + range;


						for (var i = start_year; i < end_year; i++)
							options += "<option value='" + (i) + "'>" + (i) + "</option>";
						break;
					case "%m":
						sns._time_format_order[1] = p;
						sns._time_format_order.size++;
						//month
						for (var i = 0; i < 12; i++)
							options += "<option value='" + i + "'>" + this.locale.date.month_full[i] + "</option>";
						break;
					case "%d":
						sns._time_format_order[0] = p;
						sns._time_format_order.size++;
						//days
						for (var i = 1; i < 32; i++)
							options += "<option value='" + i + "'>" + i + "</option>";
						break;
					case "%H:%i":
						//  var last = 24*60, first = 0;
						sns._time_format_order[3] = p;
						sns._time_format_order.size++;
						//hours
						var i = first;
						var tdate = dt.getDate();
						sns._time_values = [];

						while (i < last) {
							var time = this.templates.time_picker(dt);
							options += "<option value='" + i + "'>" + time + "</option>";
							sns._time_values.push(i);
							dt.setTime(dt.valueOf() + this._get_timepicker_step() * 60 * 1000);
							var diff = (dt.getDate() != tdate) ? 1 : 0; // moved or not to the next day
							i = diff * 24 * 60 + dt.getHours() * 60 + dt.getMinutes();
						}
						break;
					default:
						break;
				}

				if (options) {

					var ariaAttrs = gantt._waiAria.lightboxSelectAttrString(time_option);

					var readonly = sns.readonly ? "disabled='disabled'" : "";
					var display = hidden ? " style='display:none' " : "";
					html += "<select " + readonly + display + ariaAttrs + ">" + options + "</select>";
				}
			}
			return html;
		},
		_fill_lightbox_select: function (s, i, d, map, cfg) {
			s[i + map[0]].value = d.getDate();
			s[i + map[1]].value = d.getMonth();
			s[i + map[2]].value = d.getFullYear();
			if (gantt.defined(map[3])) {
				var v = d.getHours() * 60 + d.getMinutes();
				v = Math.round(v / gantt._get_timepicker_step()) * gantt._get_timepicker_step();
				var input = s[i + map[3]];
				input.value = v;
				//in case option not shown
				input.setAttribute('data-value', v);
			}
		},
		template: {
			render: function (sns) {
				var height = (sns.height || "30") + "px";
				return "<div class='gantt_cal_ltext gantt_cal_template' style='height:" + height + ";'></div>";
			},
			set_value: function (node, value, ev, config) {
				node.innerHTML = value || "";
			},
			get_value: function (node, ev, config) {
				return node.innerHTML || "";
			},
			focus: function (node) {
			}
		},
		textarea: {
			render: function (sns) {
				var height = (sns.height || "130") + "px";
				return "<div class='gantt_cal_ltext' style='height:" + height + ";'><textarea></textarea></div>";
			},
			set_value: function (node, value, ev) {
				this.form_blocks.textarea._get_input(node).value = value || "";
			},
			get_value: function (node, ev) {
				return this.form_blocks.textarea._get_input(node).value;
			},
			focus: function (node) {
				var a = this.form_blocks.textarea._get_input(node);
				gantt._focus(a, true);
			},
			_get_input: function (node) {
				return node.querySelector("textarea");
			}
		},
		select: {
			render: function (sns) {
				var height = (sns.height || "23") + "px";
				var html = "<div class='gantt_cal_ltext' style='height:" + height + ";'><select style='width:100%;'>";
				for (var i = 0; i < sns.options.length; i++)
					html += "<option value='" + sns.options[i].key + "'>" + sns.options[i].label + "</option>";
				html += "</select></div>";
				return html;
			},
			set_value: function (node, value, ev, sns) {
				var select = node.firstChild;
				if (!select._dhx_onchange && sns.onchange) {
					select.onchange = sns.onchange;
					select._dhx_onchange = true;
				}
				if (typeof value == "undefined")
					value = (select.options[0] || {}).value;
				select.value = value || "";
			},
			get_value: function (node, ev) {
				return node.firstChild.value;
			},
			focus: function (node) {
				var a = node.firstChild;
				gantt._focus(a, true);
			}
		},
		time: {
			render: function (sns) {
				var time = this.form_blocks.getTimePicker.call(this, sns);
				var parts = ["<div style='height:" + (sns.height || 30) + "px;padding-top:0px;font-size:inherit;text-align:center;' class='gantt_section_time'>"];
				parts.push(time);

				if (sns.single_date) {
					time = this.form_blocks.getTimePicker.call(this, sns, true);
					parts.push("<span></span>");
				} else {
					parts.push("<span style='font-weight:normal; font-size:10pt;'> &nbsp;&ndash;&nbsp; </span>");
				}

				parts.push(time);
				parts.push("</div>");
				return parts.join('');
			},
			set_value: function (node, value, ev, config) {
				var cfg = config;
				var s = node.getElementsByTagName("select");

				var map = config._time_format_order;
				var map_size = config._time_format_size;

				if (cfg.auto_end_date) {
					var _update_lightbox_select = function () {
						start_date = new Date(s[map[2]].value, s[map[1]].value, s[map[0]].value, 0, 0);
						end_date = gantt.calculateEndDate({start_date: start_date, duration: 1, task: ev});
						this.form_blocks._fill_lightbox_select(s, map.size, end_date, map, cfg);
					};
					for (var i = 0; i < 4; i++) {
						s[i].onchange = _update_lightbox_select;
					}
				}

				var mapping = gantt._resolve_default_mapping(config);

				if (typeof(mapping) === "string") mapping = {start_date: mapping};

				var start_date = ev[mapping.start_date] || new Date();
				var end_date = ev[mapping.end_date] || gantt.calculateEndDate({
					start_date: start_date,
					duration: 1,
					task: ev
				});

				this.form_blocks._fill_lightbox_select(s, 0, start_date, map, cfg);
				this.form_blocks._fill_lightbox_select(s, map.size, end_date, map, cfg);
			},

			get_value: function (node, ev, config) {
				var s = node.getElementsByTagName("select");
				var map = config._time_format_order;

				var hours = 0, minutes = 0;
				if (gantt.defined(map[3])) {
					var time = parseInt(s[map[3]].value, 10);
					hours = Math.floor(time / 60);
					minutes = time % 60;
				}
				var start_date = new Date(s[map[2]].value, s[map[1]].value, s[map[0]].value, hours, minutes);

				hours = minutes = 0;
				if (gantt.defined(map[3])) {
					var time = parseInt(s[map.size + map[3]].value, 10);
					hours = Math.floor(time / 60);
					minutes = time % 60;
				}
				var end_date = new Date(s[map[2] + map.size].value, s[map[1] + map.size].value, s[map[0] + map.size].value, hours, minutes);

				if (end_date <= start_date)
					end_date = gantt.date.add(start_date, gantt._get_timepicker_step(), "minute");

				var mapped_fields = gantt._resolve_default_mapping(config);

				var res = {
					start_date: new Date(start_date),
					end_date: new Date(end_date)
				};
				if (typeof mapped_fields == "string") {
					return res.start_date;
				} else {
					return res;
				}
			},
			focus: function (node) {
				gantt._focus(node.getElementsByTagName("select")[0]);
			}
		},
		duration: {
			render: function (sns) {
				var time = this.form_blocks.getTimePicker.call(this, sns);
				time = "<div class='gantt_time_selects'>" + time + "</div>";
				var label = this.locale.labels[this.config.duration_unit + "s"];

				var singleDate = sns.single_date ? ' style="display:none"' : "";
				var readonly = sns.readonly ? " disabled='disabled'" : "";

				var ariaAttr = this._waiAria.lightboxDurationInputAttrString(sns);

				var duration = "<div class='gantt_duration' " + singleDate + ">" +
					"<input type='button' class='gantt_duration_dec' value='−'" + readonly + ">" +
					"<input type='text' value='5' class='gantt_duration_value'" + readonly + " " + ariaAttr + ">" +
					"<input type='button' class='gantt_duration_inc' value='+'" + readonly + "> " + label + " <span></span>" +
					"</div>";
				var html = "<div style='height:" + (sns.height || 30) + "px;padding-top:0px;font-size:inherit;' class='gantt_section_time'>" + time + " " + duration + "</div>";
				return html;
			},
			set_value: function (node, value, ev, config) {
				var cfg = config;
				var s = node.getElementsByTagName("select");
				var inps = node.getElementsByTagName("input");

				var duration = inps[1];
				var btns = [inps[0], inps[2]];
				var endspan = node.getElementsByTagName("span")[0];

				var map = config._time_format_order;

				function _calc_date() {
					var start_date = gantt.form_blocks.duration._get_start_date.call(gantt, node, config);
					var duration = gantt.form_blocks.duration._get_duration.call(gantt, node, config);
					var end_date = gantt.calculateEndDate({start_date: start_date, duration: duration, task: ev});

					endspan.innerHTML = gantt.templates.task_date(end_date);
				}

				function _change_duration(step) {
					var value = duration.value;
					value = parseInt(value, 10);
					if (window.isNaN(value))
						value = 0;
					value += step;
					if (value < 1) value = 1;
					duration.value = value;
					_calc_date();
				}

				btns[0].onclick = gantt.bind(function () {
					_change_duration(-1 * this.config.duration_step);
				}, this);
				btns[1].onclick = gantt.bind(function () {
					_change_duration(1 * this.config.duration_step);
				}, this);
				s[0].onchange = _calc_date;
				s[1].onchange = _calc_date;
				s[2].onchange = _calc_date;
				if (s[3]) s[3].onchange = _calc_date;
				duration.onkeydown = gantt.bind(function (e) {
					e = e || window.event;
					// up
					var code = (e.charCode || e.keyCode || e.which);

					if (code == 40) {
						_change_duration(-1 * this.config.duration_step);
						return false;
					}
					// down
					if (code == 38) {
						_change_duration(1 * this.config.duration_step);
						return false;
					}
					window.setTimeout(function (e) {
						_calc_date();
					}, 1);
				}, this);

				duration.onchange = gantt.bind(function (e) {
					_calc_date();
				}, this);

				var mapping = gantt._resolve_default_mapping(config);
				if (typeof(mapping) === "string") mapping = {start_date: mapping};

				var start_date = ev[mapping.start_date] || new Date();
				var end_date = ev[mapping.end_date] || gantt.calculateEndDate({
					start_date: start_date,
					duration: 1,
					task: ev
				});
				var duration_val = Math.round(ev[mapping.duration]) || gantt.calculateDuration({
					start_date: start_date,
					end_date: end_date,
					task: ev
				});

				gantt.form_blocks._fill_lightbox_select(s, 0, start_date, map, cfg);
				duration.value = duration_val;
				_calc_date();
			},

			_get_start_date: function (node, config) {
				var s = node.getElementsByTagName("select");
				var map = config._time_format_order;
				var hours = 0;
				var minutes = 0;
				if (gantt.defined(map[3])) {
					var input = s[map[3]];
					var time = parseInt(input.value, 10);
					if (isNaN(time) && input.hasAttribute("data-value")) {
						time = parseInt(input.getAttribute("data-value"), 10);
					}

					hours = Math.floor(time / 60);
					minutes = time % 60;
				}
				return new Date(s[map[2]].value, s[map[1]].value, s[map[0]].value, hours, minutes);
			},
			_get_duration: function (node, config) {
				var duration = node.getElementsByTagName("input")[1];
				duration = parseInt(duration.value, 10);
				if (!duration || window.isNaN(duration)) duration = 1;
				if (duration < 0) duration *= -1;
				return duration;
			},

			get_value: function (node, ev, config) {
				var start_date = gantt.form_blocks.duration._get_start_date(node, config);
				var duration = gantt.form_blocks.duration._get_duration(node, config);

				var end_date = gantt.calculateEndDate({start_date: start_date, duration: duration, task: ev});
				var mapped_fields = gantt._resolve_default_mapping(config);
				var res = {
					start_date: new Date(start_date),
					end_date: new Date(end_date),
					duration: duration
				};
				if (typeof mapped_fields == "string") {
					return res.start_date;
				} else {
					return res;
				}
			},
			focus: function (node) {
				gantt._focus(node.getElementsByTagName("select")[0]);
			}
		},
		parent: {
			_filter: function (options, config, item_id) {
				var filter = config.filter || function () {
					return true;
				};

				options = options.slice(0);

				for (var i = 0; i < options.length; i++) {
					var task = options[i];
					if (task.id == item_id || gantt.isChildOf(task.id, item_id) || filter(task.id, task) === false) {
						options.splice(i, 1);
						i--;
					}
				}
				return options;
			},

			_display: function (config, item_id) {
				var tasks = [],
					options = [];
				if (item_id) {
					tasks = gantt.getTaskByTime();
					if (config.allow_root) {
						tasks.unshift({id: gantt.config.root_id, text: config.root_label || ""});
					}
					tasks = this._filter(tasks, config, item_id);
					if (config.sort) {
						tasks.sort(config.sort);
					}
				}
				var text = config.template || gantt.templates.task_text;
				for (var i = 0; i < tasks.length; i++) {
					var label = text.apply(gantt, [tasks[i].start_date, tasks[i].end_date, tasks[i]]);
					if (label === undefined) {
						label = "";
					}
					options.push({
						key: tasks[i].id,
						label: label
					});
				}
				config.options = options;
				config.map_to = config.map_to || "parent";
				return gantt.form_blocks.select.render.apply(this, arguments);
			},
			render: function (sns) {
				return gantt.form_blocks.parent._display(sns, false);
			},
			set_value: function (node, value, ev, config) {
				var tmpDom = document.createElement("div");
				tmpDom.innerHTML = gantt.form_blocks.parent._display(config, ev.id);
				var newOptions = tmpDom.removeChild(tmpDom.firstChild);
				node.onselect = null;
				node.parentNode.replaceChild(newOptions, node);

				return gantt.form_blocks.select.set_value.apply(gantt, [newOptions, value, ev, config]);
			},
			get_value: function () {
				return gantt.form_blocks.select.get_value.apply(gantt, arguments);
			},
			focus: function () {
				return gantt.form_blocks.select.focus.apply(gantt, arguments);
			}
		}
	};

	gantt._is_lightbox_timepicker = function () {
		var s = this._get_typed_lightbox_config();
		for (var i = 0; i < s.length; i++)
			if (s[i].name == "time" && s[i].type == "time")
				return true;
		return false;
	};

	gantt._dhtmlx_confirm = function (message, title, callback, ok) {
		if (!message)
			return callback();
		var opts = {text: message};
		if (title)
			opts.title = title;
		if (ok) {
			opts.ok = ok;
		}
		if (callback) {
			opts.callback = function (result) {
				if (result)
					callback();
			};
		}
		gantt.confirm(opts);
	};

	gantt._get_typed_lightbox_config = function (type) {
		if (type === undefined) {
			type = this.getLightboxType();
		}

		var field = this._get_type_name(type);

		if (gantt.config.lightbox[field + "_sections"]) {
			return gantt.config.lightbox[field + "_sections"];
		} else {
			return gantt.config.lightbox.sections;
		}
	};

	gantt._silent_redraw_lightbox = function (type) {
		var oldType = this.getLightboxType();

		if (this.getState().lightbox) {
			var taskId = this.getState().lightbox;
			var formData = this.getLightboxValues(),
				task = this.copy(this.getTask(taskId));

			this.resetLightbox();

			var updTask = this.mixin(task, formData, true);
			var box = this.getLightbox(type ? type : undefined);
			this._center_lightbox(this.getLightbox());
			this._set_lightbox_values(updTask, box);
		} else {
			this.resetLightbox();
			this.getLightbox(type ? type : undefined);
		}
		this.callEvent("onLightboxChange", [oldType, this.getLightboxType()]);
	};

};


//////////////////
// WEBPACK FOOTER
// ./sources/core/lightbox.js
// module id = 80
// module chunks = 0